import { Paper, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { DynamicDropdown } from "../models/dynamicDropdown"

interface Props {
  item: DynamicDropdown
}

export default function DynamicDropdownDetailContent({ item }: Props) {
  const { t } = useTranslation()

  return (
    <Stack p="md">
      <Paper withBorder p="sm" radius="md">
        <Text size="xs" tt="uppercase" c="dimmed">
          {t("dynamicDropdowns.type")}
        </Text>
        <Text>{item.type_name}</Text>
      </Paper>
      <Paper withBorder p="sm" radius="md">
        <Text size="xs" tt="uppercase" c="dimmed">
          {t("dynamicDropdowns.option")}
        </Text>
        <Text>{item.option}</Text>
      </Paper>
    </Stack>
  )
}
